export const MEMO_FIRMA_LISTAS = "FirmaListas"
